import { render } from "./GridText.vue?vue&type=template&id=572f1b1e"
import script from "./GridText.vue?vue&type=script&lang=js"
export * from "./GridText.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__